var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsertTwin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88.00018,
    height: 79.99729,
    viewBox: "0 0 88.00018 79.99729",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4892 25.2049C26.2205 24.6612 24.7512 25.2489 24.2075 26.5176C23.6637 27.7863 24.2514 29.2556 25.5201 29.7993L41.5002 36.6479V52.4948C41.5002 53.8751 42.6192 54.994 43.9995 54.994C45.3798 54.994 46.4988 53.8751 46.4988 52.4948V36.6479L62.4789 29.7993C63.7476 29.2556 64.3353 27.7863 63.7916 26.5176C63.2478 25.2489 61.7786 24.6612 60.5099 25.2049L43.9995 32.2808L27.4892 25.2049ZM49.3832 6.90089C45.9182 5.56819 42.082 5.56819 38.617 6.90089L13.8166 16.4395C10.921 17.5532 9.01038 20.3351 9.01038 23.4375V56.5598C9.01038 59.6622 10.921 62.4441 13.8166 63.5578L38.617 73.0964C42.082 74.4291 45.9182 74.4291 49.3832 73.0964L74.1836 63.5578C77.0791 62.4441 78.9898 59.6622 78.9898 56.5598V23.4375C78.9898 20.3351 77.0791 17.5532 74.1836 16.4395L49.3832 6.90089ZM40.4113 11.5662C42.7214 10.6778 45.2788 10.6778 47.5888 11.5662L72.3892 21.1048C73.3544 21.4761 73.9913 22.4034 73.9913 23.4375V56.5598C73.9913 57.5939 73.3544 58.5212 72.3892 58.8925L47.5888 68.4311C45.2788 69.3195 42.7214 69.3195 40.4114 68.4311L15.611 58.8925C14.6458 58.5212 14.0089 57.5939 14.0089 56.5598V23.4375C14.0089 22.4034 14.6458 21.4761 15.611 21.1048L40.4113 11.5662Z",
    fill: "#00BBCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertTwin);
export default __webpack_public_path__ + "static/media/insert-twin.7decb652e859d18bc771bbfead8d817b.svg";
export { ForwardRef as ReactComponent };